// @ts-check

/**
 * @typedef {object} OBQQuestionAnswer
 * @property {string} value
 * @propertu {string} text
 */

/**
 * @typedef {object} OBQQuestion
 * @property {string} slug
 * @property {string} text
 * @property {string} type
 * @property {OBQQuestionAnswer[]} answers
 */


/**
 * @see https: //stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
 */
function shuffleArray(array) {
  var currentIndex = array.length,
    temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

/** @type {OBQQuestion[]} */
export const OBQQuestions = [
  {
    slug: 'sheetKnowledge',
    text: 'What is your skill level with spreadsheets?',
    type: 'scale',
    answers: [
      {
        value: 'beginner',
        text: 'Beginner - I can review data, but I\'ve never written a formula.'
      },
      {
        value: 'intermediate',
        text: 'Intermediate - I can write basic formulas'
      },
      {
        value: 'advanced',
        text: 'Advanced -  I can write advanced formulas like array formulas, SUMIF, and VLOOKUP'
      }
    ]
  },
  {
    slug: 'goal',
    text: 'What is your primary goal with a financial tool like Tiller?',
    type: 'enum',
    answers: shuffleArray([
      {
        value: 'budget',
        text: 'Budgeting'
      },
      {
        value: 'track',
        text: 'Tracking my spending/income (I don\'t need to keep a budget)'
      },
      {
        value: 'networth',
        text: 'Tracking my net worth'
      },
      {
        value: 'debt',
        text: 'Getting out of debt'
      },
      {
        value: 'business',
        text: 'Managing business finances'
      },
      {
        value: 'feeds',
        text: 'Automating bank data into a spreadsheet'
      }
    ]).concat([
      {
        value: 'other',
        text: 'Other',
      }
    ])
  },
];

export default OBQQuestions;